import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"


export default class extends Controller {
  static targets = ['input', 'hiddenField']

  upload() {
    const file = this.inputTarget.files[0]
    const url = this.inputTarget.dataset['directUploadUrl']
    const upload = new DirectUpload(file, url)

    upload.create((error, blob) => {
      if (error) {
        console.log(error)
      } else {
        this.hiddenFieldTarget.setAttribute("value", blob.signed_id)
      }
    })
  }
}
